import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewsletterGuard } from '../../modules/shared/guards/newsletter.guard';
import { ServiziGuard } from '../../modules/shared/guards/servizi.guard';
import { ListeGuard } from '../../modules/shared/guards/liste.guard';
import { CmsModule } from '../cms/cms.module';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { StoreLocatorPageService } from './store-locator-page/store-locator-page.service';
import {ConventionGuard} from '../shared/guards/convention.guard';


const routes: Routes = [
  {
    path: '',
    data: { name: 'Home' },
    loadChildren: () => import('./home-page/home-page.module').then(m => m.HomePageModule)
  },
  {
    path: 'pagine',
    data: { name: 'Pagine', canNavigate: true },
    loadChildren: () => import('./legacy-pages/legacy-pages.module').then(m => m.LegacyPagesModule)
  },
  {
    path: 'chi-siamo',
    data: { name: 'Chi Siamo', canNavigate: true },
    loadChildren: () => import('./about-us-page/about-us-page.module').then(m => m.AboutUsPageModule)
  },
  {
    path: 'news',
    data: {name: 'News', canNavigate: true, content: "NEWS"},
    loadChildren: () => import('./news-page/news-page.module').then(m => m.NewsPageModule)
  },
  {
    path: 'conad-news',
    data: {name: 'Conad News', canNavigate: true, content: "CONAD_NEWS"},
    loadChildren: () => import('./news-page/news-page.module').then(m => m.NewsPageModule)
  },
  {
    path: 'conad-destinations',
    data: {name: 'Conad Destinations', canNavigate: true, content: "CONAD_DESTINATIONS"},
    loadChildren: () => import('./destinations-page/destinations-page.module').then(m => m.DestinationsPageModule)
  },
  {
    path:'lavora-con-noi',
    data: {name: 'Lavora con noi', canNavigate: true},
    loadChildren: () => import('./work-with-us/work-with-us.module').then(m => m.WorkWithUsModule)
  },
  {
    path: 'privacy-policy',
    data: {name: 'Privacy Policy', canNavigate: true},
    loadChildren: () => import('./privacy-page/privacy-page.module').then(m => m.PrivacyPageModule)
  },
  {
    path: 'privacy-area',
    data: {name: 'Privacy Policy', canNavigate: true},
    loadChildren: () => import('./privacy-area-page/privacy-area-page.module').then(m => m.PrivacyAreaPageModule)
  },
  {
    path: 'cookie-policy',
    data: {name: 'Cookie Policy', canNavigate: true},
    loadChildren: () => import('./cookie-page/cookie-page.module').then(m => m.CookiePageModule)
  },
  {
    path: 'contatti',
    data: {name: 'Contatti', canNavigate: true},
    loadChildren: () => import('./contacts-page/contacts-page.module').then(m => m.ContactsPageModule)
  },
  {
    path: 'servizi',
    data: {name: 'Servizi', canNavigate: true},
    canActivate: [ServiziGuard],
    loadChildren: () => import('./service-page/service-page.module').then(m => m.ServicePageModule)
  },
  {
    path: 'newsletter',
    data: {name: 'Newsletter', canNavigate: true},
    canActivate: [NewsletterGuard],
    loadChildren: () => import('./newsletter-page/newsletter-page.module').then(m => m.NewsletterPageModule)
  },
  {
    path: 'liste-eventi',
    data: {name: 'Liste', canNavigate: true},
    canActivate: [ListeGuard],
    loadChildren: () => import('./liste-page/liste-page.module').then(m => m.ListePageModule)
  },
  {
    path: 'offerte',
    data: {name: 'Offerte', cmsPath: 'offerte/', canNavigate: true},
    loadChildren: () => import('./custom-page/custom-page.module').then(m => m.CustomPageModule)
  },
  {
    path: 'le-nostre-proposte',
    data: {name: 'Le Nostre Proposte', cmsPath: 'le-nostre-proposte/', canNavigate: true},
    loadChildren: () => import('./custom-page/custom-page.module').then(m => m.CustomPageModule)
  },
  {
    path: 'conad',
    data: {name: 'Conad', cmsPath: 'conad/', canNavigate: true},
    loadChildren: () => import('./custom-page/custom-page.module').then(m => m.CustomPageModule)
  },
  {
    path: 'cerca-agenzia',
    data: {name: 'Cerca Agenzia', canNavigate: true},
    loadChildren: () => import('./store-locator-page/store-locator-page.module').then(m => m.StoreLocatorPageModule)
  },
  {
    path: 'convenzioni.html',
    data: {name: 'Convenzioni', canNavigate: true},
    canActivate: [ConventionGuard],
    loadChildren: () => import('./conventions-page/conventions-page.module').then(m => m.ConventionsPageModule)
  },
  {
    path: 'newsletter-landing',
    data: {name: 'Newsletter Landing Page', canNavigate: true},
    loadChildren: () => import('./newsletter-landing-page/newsletter-landing-page.module').then(m => m.NewsletterLandingPageModule)
  },
  {
    path: 'card-landing',
    data: {name: 'Social Landing Page', canNavigate: true, landingSource: "social"},
    loadChildren: () => import('./newsletter-landing-page/newsletter-landing-page.module').then(m => m.NewsletterLandingPageModule)
  },
  {
    path: 'qr',
    data: {name: 'QR Code Page', canNavigate: true},
    loadChildren: () => import('./qr-page/qr-page.module').then(m => m.QrPageModule)
  },

]

@NgModule({
  declarations: [],
  imports: [
    CmsModule,
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    StoreLocatorPageService
  ]
})
export class PagesModule {

}
